/**
 * Header overlay → solid scroll transition.
 * Adds .is-solid to the header when the user scrolls past 80% of viewport height.
 * Only runs when [data-header-overlay] is present (overlay mode enabled on
 * homepage via the header_overlay_first_section theme setting).
 */
(function () {
  // Publish actual header height as a CSS var so main offset + drawer top
  // match the rendered header exactly, regardless of viewport / font scale.
  var anyHeader = document.querySelector('.header-solio');
  if (anyHeader) {
    var publishHeight = function () {
      document.documentElement.style.setProperty(
        '--header-height',
        anyHeader.offsetHeight + 'px'
      );
    };
    publishHeight();
    window.addEventListener('resize', publishHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(publishHeight);
    }
  }

  var header = document.querySelector('[data-header-overlay]');
  if (!header) return;

  // Threshold: scroll past 80% of viewport on desktop, 90% on mobile.
  // Mobile viewports are short, so 80% triggers .is-solid too eagerly — the
  // header would flip to white after a single thumb-flick on a phone.
  function computeThreshold() {
    return window.innerHeight * (window.innerWidth < 750 ? 0.9 : 0.8);
  }
  var threshold = computeThreshold();
  var solid = false;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
      var past = window.scrollY > threshold;

      if (past !== solid) {
        solid = past;
        if (solid) {
          header.classList.add('is-solid');
        } else {
          header.classList.remove('is-solid');
        }
      }

      ticking = false;
    });
  }

  window.addEventListener('resize', function () {
    threshold = computeThreshold();
    onScroll();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
